import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Box, Typography, Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  last: {
    margin: 0,
  },
}));

export default function RefundVenueSettingsForm({ disabled, ...props }) {
  const { history, fetchData } = props;
  const classes = useStylesAll();
  let { id } = useParams();

  const { control, handleSubmit, setValue } = useForm();

  const formatRowToData = (row) => {
    return ({
      localizations: {
        en: {
          name: row.en,
        },
        tc: {
          name: row.tc,
        },
      },
      status: row.status || false ,
    });
  };

  useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getRefundVenueById(id)
        .then((response) => {
          console.log(response.data);
          setValue("en", response.data.localizations.en.name);
          setValue("tc", response.data.localizations.tc.name);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateVenue = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateRefundVenueById(
        id,
        formatRowToData(data)
      );
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/refund/venue-settings");
    } catch (err) {
      console.log(err);
    }
  };

  const createVenue = async (data) => {
    try {
      const result = await apiHelper.hkiff.postRefundVenue(
        formatRowToData(data)
      );
      if (result.data.code === -4) {
        toast.error("Duplicated venue code.");
      } else {
        console.log('res',result);
        toast.dark("Venue created.");

        //clear all fields
        setValue("en", "");
        setValue("tc", "");
        fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendVenue = () => {
      if (id) {
        updateVenue(data);
      } else {
        createVenue({...data, status: 1});
      }
    };
    sendVenue();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{props.description}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="en"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="tc"
              defaultValue=""
              render={({ field }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    helperText="The name is how it appears on your site."
                    {...field}
                    fullWidth
                  />
                );
              }}
            />

            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              {disabled || (
                <Box>
                  <Button
                    className={classes.last}
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                  >
                    {props.submitBtnTxt}
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
}
